import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Button, Modal } from 'antd';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { ObjectUtils } from 'src/core/utils/object';
import { ContextService } from 'src/core/services/context.service';
import { ClientFormView } from 'src/app/crm/clients/form/client-form.view';
import { ClientDataService } from 'src/app/crm/clients/form/client-form.data';
import { EntitySchemaDataService } from 'src/app/general/entity-schemas/entity-schema.data';
import { IdentityService } from 'src/core/services/identity.service';
import { FormatService } from 'src/core/services/format.service';

interface QuoteClientModalProps extends ComponentViewProps<QuoteItem> {
	type: string
	closeDialog: (client:ClientItem,ev?: React.MouseEvent<HTMLButtonElement>) => void;
	formatService: FormatService;
	showModal: boolean;
	defaultLanguage:string
}

@observer
export class QuoteClientModalController extends React.Component<QuoteClientModalProps, any> {
	@observable
	protected dataService: ClientDataService;

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected identityService: IdentityService;

	@resolve
	protected contextService: ContextService;

	@resolve
	protected toast: ToastNotifications;

	constructor(props) {
		super(props);
		this.state = { mode: 'edit', schema: undefined }
	}

	@computed
	protected get title() {
		if (this.dataService && this.dataService.item) {
			if (this.dataService.item.type == 0) {
				return `Client ${this.dataService.item.dynamicProperties['person']['firstName'] || ''} ${this.dataService.item.dynamicProperties['person']['lastName'] || ''}`;
			} else {
				return `Client ${this.dataService.item.dynamicProperties['company']['signature'] || ''}`;
			}
		}
		return '';
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.setState({ mode: mode });
	}


	@autobind
	addClient() {
		this.props.setBusy(true);
		this.dataService.items = [];
		this.dataService.add(this.props.type, this.identityService.userId,this.props.defaultLanguage)
			.then(res => {
				this.props.setBusy(false);
			}).catch(error => {
				this.props.setBusy(false);
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			});
	}

	@autobind
	public async save() {
		const item = this.dataService.item;
		const errors = await item.validate(true);
		if (errors.length == 0) {
			this.props.setBusy(true);
			if (item.type == 0) {
				item.displayName = `${item.dynamicProperties.person.firstName} ${item.dynamicProperties.person.lastName}`;
			} else {
				item.displayName = `${item.dynamicProperties.company.signature}`;
			}
			this.dataService.save()
				.then(res => {
					this.props.setBusy(false);
					const item = this.dataService.item;
					this.props.model.clientDisplayName = item.displayName;
					this.props.model.clientId = item.id;
					//this.dataService = null;
					this.toast.showDataSaved();
					this.props.closeDialog(item);
				})
				.catch((error) => {
					this.props.setBusy(false);

					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
					this.props.closeDialog(null);
				});
		} else {

			const err = errors.map(e => e.text);
			this.toast.showToast('Validation error!', err, 'error');
		}
	}

	@autobind
	public cancel() {
		return new Promise<boolean>((resolve, reject) => {
			if (this.dataService.isDirty) {
				this.dialogService.showYesNo('Warning', 'Are you sure want to close this form? Your changes will be lost!')
					.then(dialogResult => {
						if (dialogResult) {
							this.props.closeDialog(null);
						}
						resolve(true);
					})
					.catch(reject);
			} else {
				resolve(true);
			}
		});
	}

	public componentDidMount() {
		this.fetchSchema()
			.then(() => {
				this.dataService = ClientDataService.make();
				this.addClient();
			});
	}

	componentWillReceiveProps(nextProps: Readonly<QuoteClientModalProps>, nextContext: any) {
		if (this.props.model.clientId != nextProps.model.clientId)
			this.addClient();
		//if (this.dataService == null)
		//	this.dataService = ClientDataService.make();
		//if (this.dataService.item == null)
		//	this.addClient();
	}

	fetchSchema(): Promise<void> {
		const entitySchemaService = EntitySchemaDataService.make();
		entitySchemaService.pageSize = 1;

		entitySchemaService.addFilter('name', 'eq', 'client');
		entitySchemaService.addSorting('name', 'asc', true);
		return entitySchemaService.load(query => query)
			.then((data) => {
				const entitySchema = data[0];
				const schema = ObjectUtils.toObject<JsonSchema>(entitySchema.schema);
				this.setState({ schema: schema });
			});
	}

	render() {
		if (this.dataService == null || this.dataService.item == null) {
			return null;
		}

		return (<Modal className="ant-modalClient"
			visible={this.props.showModal}
			onCancel={this.cancel}
			title="Convert To client"
			maskClosable={false}
			footer={[
				<Button key='save' onClick={this.save}>Save</Button>,
				<Button key='cancel' onClick={this.cancel}>Cancel</Button>
			]}>
			<ClientFormView
				title={this.title}
				identityService={this.identityService}
				mode={this.state.mode}
				onModeChange={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={this.dataService.item}
				contextService={this.contextService}
				setBusy={this.props.setBusy}
				schema={this.state.schema}
				isNew={true}
				offset={false}
				showHeader={false}
				className={false}
			/>
		</Modal>)
			;
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quotes/form/quote-client-modal.controller.tsx